import { ArrowUpRight, ArrowDownRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { formatPercent, changeColor } from "../lib/format";

export function ChangePill({ value, className = "", showIcon = true, size = "sm" }) {
  const { i18n } = useTranslation();
  const missing = value == null || Number.isNaN(Number(value));
  const color = missing ? "text-neutral" : changeColor(value);
  const Icon = !missing && value >= 0 ? ArrowUpRight : ArrowDownRight;
  const text = size === "lg" ? "text-base" : "text-sm";
  return (
    <span
      className={`inline-flex items-center gap-1 num font-medium ${text} ${color} ${className}`}
      data-testid="change-pill"
    >
      {showIcon && !missing && <Icon className="h-3.5 w-3.5" strokeWidth={2.5} />}
      {formatPercent(value, i18n.language)}
    </span>
  );
}
